import { Link } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";
import { COLLECTIONS } from "./data";
import { useLang } from "./i18n";
import { Reveal, SectionHead } from "./Reveal";

export const Tile = ({ c, className }) => (
  <Link
    to={`/collections/${c.id}`}
    data-testid={`collection-tile-${c.id}`}
    className={`group relative overflow-hidden border border-white/10 bg-[#0D0D0D] block ${className ?? c.cls}`}
  >
    {c.img ? (
      <>
        <img src={c.img} alt={c.title} loading="lazy" className={`absolute inset-0 w-full h-full grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-1000 ease-out ${c.fit === "cover" ? "object-cover" : "object-contain p-10"}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
      </>
    ) : (
      <div className="absolute inset-0 flex items-center justify-center og-stripes">
        <img src="/img/logo.png" alt="" className="w-28 opacity-80 og-invert group-hover:rotate-12 transition-transform duration-700" />
      </div>
    )}
    <div className="absolute top-4 left-4 f-mono text-[11px] tracking-[0.25em] bg-black/70 text-white px-2 py-1">{c.tag}</div>
    <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 flex items-end justify-between gap-4">
      <h3 className="f-disp uppercase text-4xl md:text-5xl leading-[0.85] text-white">{c.title}</h3>
      <span className="shrink-0 w-11 h-11 rounded-full border border-white/40 flex items-center justify-center text-white group-hover:bg-[#FF2A2A] group-hover:border-[#FF2A2A] group-hover:text-black transition-colors duration-300">
        {c.img ? <ArrowUpRight className="w-5 h-5 group-hover:rotate-45 transition-transform duration-300" /> : <Lock className="w-4 h-4" />}
      </span>
    </div>
  </Link>
);

export const Collections = () => {
  const { t } = useLang();
  return (
  <section id="collections" data-testid="collections-section" className="px-5 md:px-10 py-24 md:py-36 bg-[#050505]">
    <SectionHead idx="02" kicker={t("col.kicker")} title={<>Collec<br />tions</>} />
    <Reveal>
      <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-3 md:h-[86vh] md:min-h-[640px]">
        {COLLECTIONS.map((c) => <Tile key={c.id} c={c} />)}
      </div>
    </Reveal>
  </section>
  );
};
